import { Controller } from "@hotwired/stimulus";

export default class extends Controller { 
  static targets = ["loader", "content"];

  startLoading() {
    $(this.loaderTarget).show();
    $(this.contentTarget).animate({ opacity: 0.1 }, "fast");
  }
}
